// src/documents/lorTemplate.js
//
// Mapa de campos del paquete LOR sobre src/assets/documents/lor-template.pdf
// (versión limpia del cliente, 2026-09-23: sin firma ni fechas):
//   pág 1  Claim Process Disclosure Form (DFS-H1-1982)
//   pág 2  Statement of Policyholder Rights
//   pág 3-8 Florida Public Adjuster Contract (datos del caso en la pág 3,
//          honorario en la pág 7, bloque de firmas en la pág 8)
// Coordenadas (y = 0 arriba) tomadas de la posición del texto en el PDF.
// Firmas, iniciales y fechas NO se llenan: se marcan al firmar.
// Los datos del PA (Luis R. Claudio) ya vienen impresos en la plantilla.

const ROW = 1.6; // los datos de la tabla van sobre la misma línea base que su etiqueta

export const LOR_TEMPLATE = {
  fields: [
    // Pág 1 — DFS: INSURED NAME(S)
    { key: 'insuredNames', page: 0, x: 178, y: 619.3 + ROW, width: 352, size: 11 },

    // Pág 2 — Rights: POLICYHOLDER NAME(S) ×2
    { key: 'insured1', page: 1, x: 136, y: 642.1 + ROW, width: 238, size: 10 },
    { key: 'insured2', page: 1, x: 136, y: 691.8 + ROW, width: 238, size: 10 },

    // Pág 3 — POLICYHOLDERS
    { key: 'insuredNames', page: 2, x: 234, y: 266, width: 152 },
    { key: 'clientEmail', page: 2, x: 393, y: 266, width: 192 },
    { key: 'addressStreet', page: 2, x: 58, y: 286.8 + ROW, width: 172 },
    { key: 'addressCity', page: 2, x: 262, y: 286.8 + ROW, width: 124 },
    { key: 'addressState', page: 2, x: 425, y: 286.8 + ROW, width: 52 },
    { key: 'addressZip', page: 2, x: 506, y: 286.8 + ROW, width: 80 },
    { key: 'clientPhone', page: 2, x: 50, y: 312 + ROW, width: 180 },
    { key: 'clientMobile', page: 2, x: 276, y: 312 + ROW, width: 110 },

    // Pág 3 — INSURANCE COMPANY(IES)
    { key: 'insuranceCompany', page: 2, x: 30, y: 389.2 + ROW, width: 242 },
    { key: 'policyNumber', page: 2, x: 320, y: 389.2 + ROW, width: 92 },
    { key: 'claimNumber', page: 2, x: 460, y: 389.2 + ROW, width: 126 },
    { key: 'insuranceAddress', page: 2, x: 58, y: 421.2 + ROW, width: 214 },
    { key: 'fieldAdjuster', page: 2, x: 100, y: 446.4 + ROW, width: 172 },
    { key: 'fieldAdjusterPhone', page: 2, x: 316, y: 446.4 + ROW, width: 96 },
    { key: 'fieldAdjusterEmail', page: 2, x: 420, y: 446.4 + ROW, width: 166 },
    { key: 'deskAdjuster', page: 2, x: 100, y: 471.6 + ROW, width: 172 },
    { key: 'deskAdjusterPhone', page: 2, x: 316, y: 471.6 + ROW, width: 96 },
    { key: 'deskAdjusterEmail', page: 2, x: 420, y: 471.6 + ROW, width: 166 },

    // Pág 3 — LOSS LOCATION/DESCRIPTION
    { key: 'lossStreet', page: 2, x: 86, y: 562.9 + ROW, width: 124 },
    { key: 'lossCity', page: 2, x: 244, y: 562.9 + ROW, width: 116 },
    { key: 'lossStateZip', page: 2, x: 420, y: 562.9 + ROW, width: 166 },
    { key: 'dateOfLoss', page: 2, x: 84, y: 595 + ROW, width: 126 },
    { key: 'lossDescription', page: 2, x: 362, y: 595 + ROW, width: 224 },
    { key: 'claimTypeEmergency', page: 2, x: 178, y: 620.2 + ROW, width: 30, size: 12 },
    { key: 'claimTypeNonEmergency', page: 2, x: 326, y: 620.2 + ROW, width: 30, size: 12 },
    { key: 'claimTypeSupplemental', page: 2, x: 452, y: 620.2 + ROW, width: 30, size: 12 },

    // Pág 7 — honorario (reemplaza el "20 %" fijo; mismo estilo Times negrita 18)
    { key: 'feePercent', page: 6, x: 386.5, y: 138.5 + ROW, width: 40, size: 18, font: 'timesBold', plain: true },

    // Pág 8 — nombres impresos (firmas y fechas van al firmar)
    { key: 'paPrinted', page: 7, x: 236, y: 155.2 + ROW, width: 190 },
    { key: 'insured1', page: 7, x: 236, y: 364.4 + ROW, width: 190 },
    { key: 'insured2', page: 7, x: 236, y: 473.2 + ROW, width: 190 }
  ],

  patches: [
    { page: 6, x: 386, y: 124.5, width: 40.5, height: 17 } // "20 %" fijo
  ]
};
